import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function assertNonEmptyString(str) {
  if (typeof str !== 'string' || !str) {
    throw new Error('expected a non-empty string, got: ' + str);
  }
}

function assertNumber(number) {
  if (typeof number !== 'number') {
    throw new Error('expected a number, got: ' + number);
  }
}

var DB_VERSION_CURRENT = 1;
var DB_VERSION_INITIAL = 1;
var STORE_EMOJI = 'emoji';
var STORE_KEYVALUE = 'keyvalue';
var STORE_FAVORITES = 'favorites';
var FIELD_TOKENS = 'tokens';
var INDEX_TOKENS = 'tokens';
var FIELD_UNICODE = 'unicode';
var INDEX_COUNT = 'count';
var FIELD_GROUP = 'group';
var FIELD_ORDER = 'order';
var INDEX_GROUP_AND_ORDER = 'group-order';
var KEY_ETAG = 'eTag';
var KEY_URL = 'url';
var KEY_PREFERRED_SKINTONE = 'skinTone';
var MODE_READONLY = 'readonly';
var MODE_READWRITE = 'readwrite';
var INDEX_SKIN_UNICODE = 'skinUnicodes';
var FIELD_SKIN_UNICODE = 'skinUnicodes';
var DEFAULT_DATA_SOURCE = 'https://cdn.jsdelivr.net/npm/emoji-picker-element-data@^1/en/emojibase/data.json';
var DEFAULT_LOCALE = 'en'; // like lodash's uniqBy but much smaller

function uniqBy(arr, func) {
  var set = new Set();
  var res = [];

  var _iterator = _createForOfIteratorHelper(arr),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var key = func(item);

      if (!set.has(key)) {
        set.add(key);
        res.push(item);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return res;
}

function uniqEmoji(emojis) {
  return uniqBy(emojis, function (_) {
    return _.unicode;
  });
}

function initialMigration(db) {
  var _createObjectStore;

  function createObjectStore(name, keyPath, indexes) {
    var store = keyPath ? db.createObjectStore(name, {
      keyPath: keyPath
    }) : db.createObjectStore(name);

    if (indexes) {
      for (var _i2 = 0, _Object$entries = Object.entries(indexes); _i2 < _Object$entries.length; _i2++) {
        var _ref3 = _Object$entries[_i2];

        var _ref2 = _slicedToArray(_ref3, 2);

        var indexName = _ref2[0];

        var _ref2$ = _slicedToArray(_ref2[1], 2);

        var _keyPath = _ref2$[0];
        var multiEntry = _ref2$[1];
        store.createIndex(indexName, _keyPath, {
          multiEntry: multiEntry
        });
      }
    }

    return store;
  }

  createObjectStore(STORE_KEYVALUE);
  createObjectStore(STORE_EMOJI,
  /* keyPath */
  FIELD_UNICODE, (_createObjectStore = {}, _defineProperty(_createObjectStore, INDEX_TOKENS, [FIELD_TOKENS,
  /* multiEntry */
  true]), _defineProperty(_createObjectStore, INDEX_GROUP_AND_ORDER, [[FIELD_GROUP, FIELD_ORDER]]), _defineProperty(_createObjectStore, INDEX_SKIN_UNICODE, [FIELD_SKIN_UNICODE,
  /* multiEntry */
  true]), _createObjectStore));
  createObjectStore(STORE_FAVORITES, undefined, _defineProperty({}, INDEX_COUNT, ['']));
}

var openReqs = {};
var databaseCache = {};
var onCloseListeners = {};

function handleOpenOrDeleteReq(resolve, reject, req) {
  // These things are almost impossible to test with fakeIndexedDB sadly

  /* istanbul ignore next */
  req.onerror = function () {
    return reject(req.error);
  };
  /* istanbul ignore next */


  req.onblocked = function () {
    return reject(new Error('IDB blocked'));
  };

  req.onsuccess = function () {
    return resolve(req.result);
  };
}

function createDatabase(_x) {
  return _createDatabase.apply(this, arguments);
}

function _createDatabase() {
  _createDatabase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(dbName) {
    var db;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return new Promise(function (resolve, reject) {
              var req = indexedDB.open(dbName, DB_VERSION_CURRENT);
              openReqs[dbName] = req;

              req.onupgradeneeded = function (e) {
                // Technically there is only one version, so we don't need this `if` check
                // But if an old version of the JS is in another browser tab
                // and it gets upgraded in the future and we have a new DB version, well...
                // better safe than sorry.

                /* istanbul ignore else */
                if (e.oldVersion < DB_VERSION_INITIAL) {
                  initialMigration(req.result);
                }
              };

              handleOpenOrDeleteReq(resolve, reject, req);
            });

          case 2:
            db = _context14.sent;

            // Handle abnormal closes, e.g. "delete database" in chrome dev tools.
            // No need for removeEventListener, because once the DB can no longer
            // fire "close" events, it will auto-GC.
            // Unfortunately cannot test in fakeIndexedDB: https://github.com/dumbmatter/fakeIndexedDB/issues/50

            /* istanbul ignore next */
            db.onclose = function () {
              return closeDatabase(dbName);
            };

            return _context14.abrupt("return", db);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _createDatabase.apply(this, arguments);
}

function openDatabase(dbName) {
  if (!databaseCache[dbName]) {
    databaseCache[dbName] = createDatabase(dbName);
  }

  return databaseCache[dbName];
}

function dbPromise(db, storeName, readOnlyOrReadWrite, cb) {
  return new Promise(function (resolve, reject) {
    var tx = db.transaction(storeName, readOnlyOrReadWrite);
    var store = typeof storeName === 'string' ? tx.objectStore(storeName) : storeName.map(function (name) {
      return tx.objectStore(name);
    });
    var res;
    cb(store, function (result) {
      res = result;
    });

    tx.oncomplete = function () {
      return resolve(res);
    };
    /* istanbul ignore next */


    tx.onerror = function () {
      return reject(tx.error);
    };
  });
}

function closeDatabase(dbName) {
  // close any open requests
  var req = openReqs[dbName];
  var db = req && req.result;

  if (db) {
    db.close();
    var listeners = onCloseListeners[dbName];
    /* istanbul ignore else */

    if (listeners) {
      var _iterator2 = _createForOfIteratorHelper(listeners),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var listener = _step2.value;
          listener();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }

  delete openReqs[dbName];
  delete databaseCache[dbName];
  delete onCloseListeners[dbName];
}

function deleteDatabase(dbName) {
  return new Promise(function (resolve, reject) {
    // close any open requests
    closeDatabase(dbName);
    var req = indexedDB.deleteDatabase(dbName);
    handleOpenOrDeleteReq(resolve, reject, req);
  });
} // The "close" event occurs during an abnormal shutdown, e.g. a user clearing their browser data.
// However, it doesn't occur with the normal "close" event, so we handle that separately.
// https://www.w3.org/TR/IndexedDB/#close-a-database-connection


function addOnCloseListener(dbName, listener) {
  var listeners = onCloseListeners[dbName];

  if (!listeners) {
    listeners = onCloseListeners[dbName] = [];
  }

  listeners.push(listener);
} // list of emoticons that don't match a simple \W+ regex
// extracted using:
// require('emojibase-data/en/data.json').map(_ => _.emoticon).filter(Boolean).filter(_ => !/^\W+$/.test(_))


var irregularEmoticons = new Set([':D', 'xD', ":'D", 'o:)', ':x', ':p', ';p', 'xp', ':l', ':z', ':j', '8D', 'xo', '8)', ':B', ':o', ':s', ":'o", 'Dx', 'x(', 'D:', ':c', '>0)', ':3', '</3', '<3', '\\m/', ':E', '8#']);

function extractTokens(str) {
  return str.split(/[\s_]+/).map(function (word) {
    if (!word.match(/\w/) || irregularEmoticons.has(word)) {
      // for pure emoticons like :) or :-), just leave them as-is
      return word.toLowerCase();
    }

    return word.replace(/[)(:,]/g, '').replace(/’/g, "'").toLowerCase();
  }).filter(Boolean);
}

var MIN_SEARCH_TEXT_LENGTH = 2; // This is an extra step in addition to extractTokens(). The difference here is that we expect
// the input to have already been run through extractTokens(). This is useful for cases like
// emoticons, where we don't want to do any tokenization (because it makes no sense to split up
// ">:)" by the colon) but we do want to lowercase it to have consistent search results, so that
// the user can type ':P' or ':p' and still get the same result.

function normalizeTokens(str) {
  return str.filter(Boolean).map(function (_) {
    return _.toLowerCase();
  }).filter(function (_) {
    return _.length >= MIN_SEARCH_TEXT_LENGTH;
  });
} // Transform emoji data for storage in IDB


function transformEmojiData(emojiData) {
  var res = emojiData.map(function (_ref4) {
    var annotation = _ref4.annotation,
        emoticon = _ref4.emoticon,
        group = _ref4.group,
        order = _ref4.order,
        shortcodes = _ref4.shortcodes,
        skins = _ref4.skins,
        tags = _ref4.tags,
        emoji = _ref4.emoji,
        version = _ref4.version;

    var tokens = _toConsumableArray(new Set(normalizeTokens([].concat(_toConsumableArray((shortcodes || []).map(extractTokens).flat()), _toConsumableArray(tags.map(extractTokens).flat()), _toConsumableArray(extractTokens(annotation)), [emoticon])))).sort();

    var res = {
      annotation: annotation,
      group: group,
      order: order,
      tags: tags,
      tokens: tokens,
      unicode: emoji,
      version: version
    };

    if (emoticon) {
      res.emoticon = emoticon;
    }

    if (shortcodes) {
      res.shortcodes = shortcodes;
    }

    if (skins) {
      res.skinTones = [];
      res.skinUnicodes = [];
      res.skinVersions = [];

      var _iterator3 = _createForOfIteratorHelper(skins),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _ref6 = _step3.value;
          var tone = _ref6.tone;
          var _emoji = _ref6.emoji;
          var _version = _ref6.version;
          res.skinTones.push(tone);
          res.skinUnicodes.push(_emoji);
          res.skinVersions.push(_version);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    return res;
  });
  return res;
} // helper functions that help compress the code better


function callStore(store, method, key, cb) {
  store[method](key).onsuccess = function (e) {
    return cb && cb(e.target.result);
  };
}

function getIDB(store, key, cb) {
  callStore(store, 'get', key, cb);
}

function getAllIDB(store, key, cb) {
  callStore(store, 'getAll', key, cb);
}

function getAllKeysIDB(store, key, cb) {
  callStore(store, 'getAllKeys', key, cb);
} // like lodash's minBy


function minBy(array, func) {
  var minItem = array[0];

  for (var i = 1; i < array.length; i++) {
    var item = array[i];

    if (func(minItem) > func(item)) {
      minItem = item;
    }
  }

  return minItem;
} // return an array of results representing all items that are found in each one of the arrays


function findCommonMembers(arrays, uniqByFunc) {
  var shortestArray = minBy(arrays, function (_) {
    return _.length;
  });
  var results = [];

  var _iterator4 = _createForOfIteratorHelper(shortestArray),
      _step4;

  try {
    var _loop = function _loop() {
      var item = _step4.value;

      // if this item is included in every array in the intermediate results, add it to the final results
      if (!arrays.some(function (array) {
        return array.findIndex(function (_) {
          return uniqByFunc(_) === uniqByFunc(item);
        }) === -1;
      })) {
        results.push(item);
      }
    };

    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return results;
}

function isEmpty(_x2) {
  return _isEmpty.apply(this, arguments);
}

function _isEmpty() {
  _isEmpty = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(db) {
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return get(db, STORE_KEYVALUE, KEY_URL);

          case 2:
            return _context15.abrupt("return", !_context15.sent);

          case 3:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _isEmpty.apply(this, arguments);
}

function hasData(_x3, _x4, _x5) {
  return _hasData.apply(this, arguments);
}

function _hasData() {
  _hasData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(db, url, eTag) {
    var _yield$Promise$all, _yield$Promise$all2, oldETag, oldUrl;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return Promise.all([KEY_ETAG, KEY_URL].map(function (key) {
              return get(db, STORE_KEYVALUE, key);
            }));

          case 2:
            _yield$Promise$all = _context16.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            oldETag = _yield$Promise$all2[0];
            oldUrl = _yield$Promise$all2[1];
            return _context16.abrupt("return", oldETag === eTag && oldUrl === url);

          case 7:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
  return _hasData.apply(this, arguments);
}

function doFullDatabaseScanForSingleResult(_x6, _x7) {
  return _doFullDatabaseScanForSingleResult.apply(this, arguments);
}

function _doFullDatabaseScanForSingleResult() {
  _doFullDatabaseScanForSingleResult = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(db, predicate) {
    var BATCH_SIZE;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            // This batching algorithm is just a perf improvement over a basic
            // cursor. The BATCH_SIZE is an estimate of what would give the best
            // perf for doing a full DB scan (worst case).
            //
            // Mini-benchmark for determining the best batch size:
            //
            // PERF=1 yarn build:rollup && yarn test:adhoc
            //
            // (async () => {
            //   performance.mark('start')
            //   await $('emoji-picker').database.getEmojiByShortcode('doesnotexist')
            //   performance.measure('total', 'start')
            //   console.log(performance.getEntriesByName('total').slice(-1)[0].duration)
            // })()
            BATCH_SIZE = 50; // Typically around 150ms for 6x slowdown in Chrome for above benchmark

            return _context17.abrupt("return", dbPromise(db, STORE_EMOJI, MODE_READONLY, function (emojiStore, cb) {
              var lastKey;

              var processNextBatch = function processNextBatch() {
                emojiStore.getAll(lastKey && IDBKeyRange.lowerBound(lastKey, true), BATCH_SIZE).onsuccess = function (e) {
                  var results = e.target.result;

                  var _iterator10 = _createForOfIteratorHelper(results),
                      _step10;

                  try {
                    for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                      var result = _step10.value;
                      lastKey = result.unicode;

                      if (predicate(result)) {
                        return cb(result);
                      }
                    }
                  } catch (err) {
                    _iterator10.e(err);
                  } finally {
                    _iterator10.f();
                  }

                  if (results.length < BATCH_SIZE) {
                    return cb();
                  }

                  processNextBatch();
                };
              };

              processNextBatch();
            }));

          case 2:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
  return _doFullDatabaseScanForSingleResult.apply(this, arguments);
}

function loadData(_x8, _x9, _x10, _x11) {
  return _loadData.apply(this, arguments);
}

function _loadData() {
  _loadData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(db, emojiData, url, eTag) {
    var transformedData;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            transformedData = transformEmojiData(emojiData);
            _context18.next = 4;
            return dbPromise(db, [STORE_EMOJI, STORE_KEYVALUE], MODE_READWRITE, function (_ref13) {
              var _ref14 = _slicedToArray(_ref13, 2),
                  emojiStore = _ref14[0],
                  metaStore = _ref14[1];

              var oldETag;
              var oldUrl;
              var oldKeys;
              var todo = 0;

              function checkFetched() {
                if (++todo === 3) {
                  onFetched();
                }
              }

              function onFetched() {
                if (oldETag === eTag && oldUrl === url) {
                  // check again within the transaction to guard against concurrency, e.g. multiple browser tabs
                  return;
                } // delete old data


                // delete old data
                var _iterator11 = _createForOfIteratorHelper(oldKeys),
                    _step11;

                try {
                  // delete old data
                  for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                    var key = _step11.value;
                    emojiStore.delete(key);
                  } // insert new data

                } catch (err) {
                  _iterator11.e(err);
                } finally {
                  _iterator11.f();
                } // insert new data


                // insert new data
                var _iterator12 = _createForOfIteratorHelper(transformedData),
                    _step12;

                try {
                  // insert new data
                  for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                    var data = _step12.value;
                    emojiStore.put(data);
                  }
                } catch (err) {
                  _iterator12.e(err);
                } finally {
                  _iterator12.f();
                }

                metaStore.put(eTag, KEY_ETAG);
                metaStore.put(url, KEY_URL);
              }

              getIDB(metaStore, KEY_ETAG, function (result) {
                oldETag = result;
                checkFetched();
              });
              getIDB(metaStore, KEY_URL, function (result) {
                oldUrl = result;
                checkFetched();
              });
              getAllKeysIDB(emojiStore, undefined, function (result) {
                oldKeys = result;
                checkFetched();
              });
            });

          case 4:
            _context18.prev = 4;
            return _context18.finish(4);

          case 6:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0,, 4, 6]]);
  }));
  return _loadData.apply(this, arguments);
}

function _getEmojiByGroup2(_x12, _x13) {
  return _getEmojiByGroup.apply(this, arguments);
}

function _getEmojiByGroup() {
  _getEmojiByGroup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(db, group) {
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", dbPromise(db, STORE_EMOJI, MODE_READONLY, function (emojiStore, cb) {
              var range = IDBKeyRange.bound([group, 0], [group + 1, 0], false, true);
              getAllIDB(emojiStore.index(INDEX_GROUP_AND_ORDER), range, cb);
            }));

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _getEmojiByGroup.apply(this, arguments);
}

function _getEmojiBySearchQuery2(_x14, _x15) {
  return _getEmojiBySearchQuery.apply(this, arguments);
} // This could have been implemented as an IDB index on shortcodes, but it seemed wasteful to do that
// when we can already query by tokens and this will give us what we're looking for 99.9% of the time


function _getEmojiBySearchQuery() {
  _getEmojiBySearchQuery = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(db, query) {
    var tokens;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            tokens = normalizeTokens(extractTokens(query));

            if (tokens.length) {
              _context20.next = 3;
              break;
            }

            return _context20.abrupt("return", []);

          case 3:
            return _context20.abrupt("return", dbPromise(db, STORE_EMOJI, MODE_READONLY, function (emojiStore, cb) {
              // get all results that contain all tokens (i.e. an AND query)
              var intermediateResults = [];

              var checkDone = function checkDone() {
                if (intermediateResults.length === tokens.length) {
                  onDone();
                }
              };

              var onDone = function onDone() {
                var results = findCommonMembers(intermediateResults, function (_) {
                  return _.unicode;
                });
                cb(results.sort(function (a, b) {
                  return a.order < b.order ? -1 : 1;
                }));
              };

              for (var i = 0; i < tokens.length; i++) {
                var token = tokens[i];
                var range = i === tokens.length - 1 ? IDBKeyRange.bound(token, token + "\uFFFF", false, true) // treat last token as a prefix search
                : // treat last token as a prefix search
                IDBKeyRange.only(token); // treat all other tokens as an exact match

                // treat all other tokens as an exact match
                getAllIDB(emojiStore.index(INDEX_TOKENS), range, function (result) {
                  intermediateResults.push(result);
                  checkDone();
                });
              }
            }));

          case 4:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _getEmojiBySearchQuery.apply(this, arguments);
}

function _getEmojiByShortcode2(_x16, _x17) {
  return _getEmojiByShortcode.apply(this, arguments);
}

function _getEmojiByShortcode() {
  _getEmojiByShortcode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(db, shortcode) {
    var emojis, predicate;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return _getEmojiBySearchQuery2(db, shortcode);

          case 2:
            emojis = _context21.sent;

            if (emojis.length) {
              _context21.next = 11;
              break;
            }

            predicate = function predicate(_) {
              return (_.shortcodes || []).includes(shortcode.toLowerCase());
            };

            _context21.next = 7;
            return doFullDatabaseScanForSingleResult(db, predicate);

          case 7:
            _context21.t0 = _context21.sent;

            if (_context21.t0) {
              _context21.next = 10;
              break;
            }

            _context21.t0 = null;

          case 10:
            return _context21.abrupt("return", _context21.t0);

          case 11:
            return _context21.abrupt("return", emojis.filter(function (_) {
              var lowerShortcodes = (_.shortcodes || []).map(function (_) {
                return _.toLowerCase();
              });
              return lowerShortcodes.includes(shortcode.toLowerCase());
            })[0] || null);

          case 12:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _getEmojiByShortcode.apply(this, arguments);
}

function getEmojiByUnicode(_x18, _x19) {
  return _getEmojiByUnicode.apply(this, arguments);
}

function _getEmojiByUnicode() {
  _getEmojiByUnicode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(db, unicode) {
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            return _context22.abrupt("return", dbPromise(db, STORE_EMOJI, MODE_READONLY, function (emojiStore, cb) {
              return getIDB(emojiStore, unicode, function (result) {
                if (result) {
                  return cb(result);
                }

                getIDB(emojiStore.index(INDEX_SKIN_UNICODE), unicode, function (result) {
                  return cb(result || null);
                });
              });
            }));

          case 1:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _getEmojiByUnicode.apply(this, arguments);
}

function get(db, storeName, key) {
  return dbPromise(db, storeName, MODE_READONLY, function (store, cb) {
    return getIDB(store, key, cb);
  });
}

function set(db, storeName, key, value) {
  return dbPromise(db, storeName, MODE_READWRITE, function (store) {
    return store.put(value, key);
  });
}

function _incrementFavoriteEmojiCount(db, unicode) {
  return dbPromise(db, STORE_FAVORITES, MODE_READWRITE, function (store) {
    getIDB(store, unicode, function (result) {
      return store.put((result || 0) + 1, unicode);
    });
  });
}

function _getTopFavoriteEmoji(db, customEmojiIndex, limit) {
  if (limit === 0) {
    return [];
  }

  return dbPromise(db, [STORE_FAVORITES, STORE_EMOJI], MODE_READONLY, function (_ref7, cb) {
    var _ref8 = _slicedToArray(_ref7, 2),
        favoritesStore = _ref8[0],
        emojiStore = _ref8[1];

    var results = [];

    favoritesStore.index(INDEX_COUNT).openCursor(undefined, 'prev').onsuccess = function (e) {
      var cursor = e.target.result;

      if (!cursor) {
        // no more results
        return cb(results);
      }

      function addResult(result) {
        results.push(result);

        if (results.length === limit) {
          return cb(results); // done, reached the limit
        }

        cursor.continue();
      }

      var unicodeOrName = cursor.primaryKey;
      var custom = customEmojiIndex.byName(unicodeOrName);

      if (custom) {
        return addResult(custom);
      } // This could be done in parallel (i.e. make the cursor and the get()s parallelized),
      // but my testing suggests it's not actually faster.


      getIDB(emojiStore, unicodeOrName, function (emoji) {
        if (emoji) {
          return addResult(emoji);
        } // emoji not found somehow, ignore (may happen if custom emoji change)


        cursor.continue();
      });
    };
  });
} // trie data structure for prefix searches
// loosely based on https://github.com/nolanlawson/substring-trie


var CODA_MARKER = ''; // marks the end of the string

function trie(arr, itemToTokens) {
  var map = new Map();

  var _iterator5 = _createForOfIteratorHelper(arr),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var item = _step5.value;
      var tokens = itemToTokens(item);

      var _iterator7 = _createForOfIteratorHelper(tokens),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var token = _step7.value;
          var currentMap = map;

          for (var i = 0; i < token.length; i++) {
            var char = token.charAt(i);
            var nextMap = currentMap.get(char);

            if (!nextMap) {
              nextMap = new Map();
              currentMap.set(char, nextMap);
            }

            currentMap = nextMap;
          }

          var valuesAtCoda = currentMap.get(CODA_MARKER);

          if (!valuesAtCoda) {
            valuesAtCoda = [];
            currentMap.set(CODA_MARKER, valuesAtCoda);
          }

          valuesAtCoda.push(item);
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var search = function search(query, exact) {
    var currentMap = map;

    for (var i = 0; i < query.length; i++) {
      var char = query.charAt(i);
      var nextMap = currentMap.get(char);

      if (nextMap) {
        currentMap = nextMap;
      } else {
        return [];
      }
    }

    if (exact) {
      var _results = currentMap.get(CODA_MARKER);

      return _results || [];
    }

    var results = []; // traverse

    var queue = [currentMap];

    while (queue.length) {
      var _currentMap = queue.shift();

      var entriesSortedByKey = _toConsumableArray(_currentMap.entries()).sort(function (a, b) {
        return a[0] < b[0] ? -1 : 1;
      });

      var _iterator6 = _createForOfIteratorHelper(entriesSortedByKey),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _ref11 = _step6.value;

          var _ref10 = _slicedToArray(_ref11, 2);

          var key = _ref10[0];
          var value = _ref10[1];

          if (key === CODA_MARKER) {
            // CODA_MARKER always comes first; it's the empty string
            results.push.apply(results, _toConsumableArray(value));
          } else {
            queue.push(value);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }

    return results;
  };

  return search;
}

var requiredKeys = ['name', 'url'];

function assertCustomEmojis(customEmojis) {
  var isArray = customEmojis && Array.isArray(customEmojis);
  var firstItemIsFaulty = isArray && customEmojis.length && (!customEmojis[0] || requiredKeys.some(function (key) {
    return !(key in customEmojis[0]);
  }));

  if (!isArray || firstItemIsFaulty) {
    throw new Error('Custom emojis are in the wrong format');
  }
}

function customEmojiIndex(customEmojis) {
  assertCustomEmojis(customEmojis);

  var sortByName = function sortByName(a, b) {
    return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1;
  }; //
  // all()
  //


  var all = customEmojis.sort(sortByName); //
  // search()
  //

  var emojiToTokens = function emojiToTokens(emoji) {
    return _toConsumableArray(new Set((emoji.shortcodes || []).map(function (shortcode) {
      return extractTokens(shortcode);
    }).flat()));
  };

  var searchTrie = trie(customEmojis, emojiToTokens);

  var searchByExactMatch = function searchByExactMatch(_) {
    return searchTrie(_, true);
  };

  var searchByPrefix = function searchByPrefix(_) {
    return searchTrie(_, false);
  }; // Search by query for custom emoji. Similar to how we do this in IDB, the last token
  // is treated as a prefix search, but every other one is treated as an exact match.
  // Then we AND the results together


  var search = function search(query) {
    var tokens = extractTokens(query);
    var intermediateResults = tokens.map(function (token, i) {
      return (i < tokens.length - 1 ? searchByExactMatch : searchByPrefix)(token);
    });
    return findCommonMembers(intermediateResults, function (_) {
      return _.name;
    }).sort(sortByName);
  }; //
  // byShortcode, byName
  //


  var shortcodeToEmoji = new Map();
  var nameToEmoji = new Map();

  var _iterator8 = _createForOfIteratorHelper(customEmojis),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var customEmoji = _step8.value;
      nameToEmoji.set(customEmoji.name.toLowerCase(), customEmoji);

      var _iterator9 = _createForOfIteratorHelper(customEmoji.shortcodes || []),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var shortcode = _step9.value;
          shortcodeToEmoji.set(shortcode.toLowerCase(), customEmoji);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }

  var byShortcode = function byShortcode(shortcode) {
    return shortcodeToEmoji.get(shortcode.toLowerCase());
  };

  var byName = function byName(name) {
    return nameToEmoji.get(name.toLowerCase());
  };

  return {
    all: all,
    search: search,
    byShortcode: byShortcode,
    byName: byName
  };
} // remove some internal implementation details, i.e. the "tokens" array on the emoji object
// essentially, convert the emoji from the version stored in IDB to the version used in-memory


function cleanEmoji(emoji) {
  if (!emoji) {
    return emoji;
  }

  delete emoji.tokens;

  if (emoji.skinTones) {
    var len = emoji.skinTones.length;
    emoji.skins = Array(len);

    for (var i = 0; i < len; i++) {
      emoji.skins[i] = {
        tone: emoji.skinTones[i],
        unicode: emoji.skinUnicodes[i],
        version: emoji.skinVersions[i]
      };
    }

    delete emoji.skinTones;
    delete emoji.skinUnicodes;
    delete emoji.skinVersions;
  }

  return emoji;
}

function warnETag(eTag) {
  if (!eTag) {
    console.warn('emoji-picker-element is more efficient if the dataSource server exposes an ETag header.');
  }
}

var requiredKeys$1 = ['annotation', 'emoji', 'group', 'order', 'tags', 'version'];

function assertEmojiData(emojiData) {
  if (!emojiData || !Array.isArray(emojiData) || !emojiData[0] || _typeof(emojiData[0]) !== 'object' || requiredKeys$1.some(function (key) {
    return !(key in emojiData[0]);
  })) {
    throw new Error('Emoji data is in the wrong format');
  }
}

function assertStatus(response, dataSource) {
  if (Math.floor(response.status / 100) !== 2) {
    throw new Error('Failed to fetch: ' + dataSource + ':  ' + response.status);
  }
}

function getETag(_x20) {
  return _getETag.apply(this, arguments);
}

function _getETag() {
  _getETag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(dataSource) {
    var response, eTag;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.next = 2;
            return fetch(dataSource, {
              method: 'HEAD'
            });

          case 2:
            response = _context23.sent;
            assertStatus(response, dataSource);
            eTag = response.headers.get('etag');
            warnETag(eTag);
            return _context23.abrupt("return", eTag);

          case 7:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _getETag.apply(this, arguments);
}

function getETagAndData(_x21) {
  return _getETagAndData.apply(this, arguments);
} // TODO: including these in blob-util.ts causes typedoc to generate docs for them,

/**
 * Convert an `ArrayBuffer` to a binary string.
 *
 * Example:
 *
 * ```js
 * var myString = blobUtil.arrayBufferToBinaryString(arrayBuff)
 * ```
 *
 * @param buffer - array buffer
 * @returns binary string
 */


function _getETagAndData() {
  _getETagAndData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(dataSource) {
    var response, eTag, emojiData;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.next = 2;
            return fetch(dataSource);

          case 2:
            response = _context24.sent;
            assertStatus(response, dataSource);
            eTag = response.headers.get('etag');
            warnETag(eTag);
            _context24.next = 8;
            return response.json();

          case 8:
            emojiData = _context24.sent;
            assertEmojiData(emojiData);
            return _context24.abrupt("return", [eTag, emojiData]);

          case 11:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _getETagAndData.apply(this, arguments);
}

function arrayBufferToBinaryString(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var length = bytes.byteLength;
  var i = -1;

  while (++i < length) {
    binary += String.fromCharCode(bytes[i]);
  }

  return binary;
}
/**
 * Convert a binary string to an `ArrayBuffer`.
 *
 * ```js
 * var myBuffer = blobUtil.binaryStringToArrayBuffer(binaryString)
 * ```
 *
 * @param binary - binary string
 * @returns array buffer
 */


function binaryStringToArrayBuffer(binary) {
  var length = binary.length;
  var buf = new ArrayBuffer(length);
  var arr = new Uint8Array(buf);
  var i = -1;

  while (++i < length) {
    arr[i] = binary.charCodeAt(i);
  }

  return buf;
} // generate a checksum based on the stringified JSON


function jsonChecksum(_x22) {
  return _jsonChecksum.apply(this, arguments);
}

function _jsonChecksum() {
  _jsonChecksum = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(object) {
    var inString, inBuffer, outBuffer, outBinString, res;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            inString = JSON.stringify(object);
            inBuffer = binaryStringToArrayBuffer(inString); // this does not need to be cryptographically secure, SHA-1 is fine

            _context25.next = 4;
            return crypto.subtle.digest('SHA-1', inBuffer);

          case 4:
            outBuffer = _context25.sent;
            outBinString = arrayBufferToBinaryString(outBuffer);
            res = btoa(outBinString);
            return _context25.abrupt("return", res);

          case 8:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));
  return _jsonChecksum.apply(this, arguments);
}

function checkForUpdates(_x23, _x24) {
  return _checkForUpdates.apply(this, arguments);
}

function _checkForUpdates() {
  _checkForUpdates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(db, dataSource) {
    var emojiData, eTag, eTagAndData, _eTagAndData;

    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            _context26.next = 2;
            return getETag(dataSource);

          case 2:
            eTag = _context26.sent;

            if (eTag) {
              _context26.next = 13;
              break;
            }

            _context26.next = 6;
            return getETagAndData(dataSource);

          case 6:
            eTagAndData = _context26.sent;
            eTag = eTagAndData[0];
            emojiData = eTagAndData[1];

            if (eTag) {
              _context26.next = 13;
              break;
            }

            _context26.next = 12;
            return jsonChecksum(emojiData);

          case 12:
            eTag = _context26.sent;

          case 13:
            _context26.next = 15;
            return hasData(db, dataSource, eTag);

          case 15:
            if (!_context26.sent) {
              _context26.next = 19;
              break;
            }

            ;
            _context26.next = 26;
            break;

          case 19:
            if (emojiData) {
              _context26.next = 24;
              break;
            }

            _context26.next = 22;
            return getETagAndData(dataSource);

          case 22:
            _eTagAndData = _context26.sent;
            emojiData = _eTagAndData[1];

          case 24:
            _context26.next = 26;
            return loadData(db, emojiData, dataSource, eTag);

          case 26:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
  return _checkForUpdates.apply(this, arguments);
}

function loadDataForFirstTime(_x25, _x26) {
  return _loadDataForFirstTime.apply(this, arguments);
}

function _loadDataForFirstTime() {
  _loadDataForFirstTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(db, dataSource) {
    var _yield$getETagAndData, _yield$getETagAndData2, eTag, emojiData;

    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            _context27.next = 2;
            return getETagAndData(dataSource);

          case 2:
            _yield$getETagAndData = _context27.sent;
            _yield$getETagAndData2 = _slicedToArray(_yield$getETagAndData, 2);
            eTag = _yield$getETagAndData2[0];
            emojiData = _yield$getETagAndData2[1];

            if (eTag) {
              _context27.next = 10;
              break;
            }

            _context27.next = 9;
            return jsonChecksum(emojiData);

          case 9:
            eTag = _context27.sent;

          case 10:
            _context27.next = 12;
            return loadData(db, emojiData, dataSource, eTag);

          case 12:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _loadDataForFirstTime.apply(this, arguments);
}

var Database = /*#__PURE__*/function () {
  function Database() {
    var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref12$dataSource = _ref12.dataSource,
        dataSource = _ref12$dataSource === void 0 ? DEFAULT_DATA_SOURCE : _ref12$dataSource,
        _ref12$locale = _ref12.locale,
        locale = _ref12$locale === void 0 ? DEFAULT_LOCALE : _ref12$locale,
        _ref12$customEmoji = _ref12.customEmoji,
        customEmoji = _ref12$customEmoji === void 0 ? [] : _ref12$customEmoji;

    _classCallCheck(this, Database);

    this.dataSource = dataSource;
    this.locale = locale;
    this._dbName = "emoji-picker-element-".concat(this.locale);
    this._db = undefined;
    this._lazyUpdate = undefined;
    this._custom = customEmojiIndex(customEmoji);
    this._clear = this._clear.bind(this);
    this._ready = this._init();
  }

  _createClass(Database, [{
    key: "_init",
    value: function () {
      var _init2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var db, dataSource, empty;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return openDatabase(this._dbName);

              case 2:
                db = this._db = _context.sent;
                addOnCloseListener(this._dbName, this._clear);
                dataSource = this.dataSource;
                _context.next = 7;
                return isEmpty(db);

              case 7:
                empty = _context.sent;

                if (!empty) {
                  _context.next = 13;
                  break;
                }

                _context.next = 11;
                return loadDataForFirstTime(db, dataSource);

              case 11:
                _context.next = 14;
                break;

              case 13:
                // offline-first - do an update asynchronously
                this._lazyUpdate = checkForUpdates(db, dataSource);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _init() {
        return _init2.apply(this, arguments);
      }

      return _init;
    }()
  }, {
    key: "ready",
    value: function () {
      var _ready = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._ready) {
                  this._ready = this._init();
                }

                return _context2.abrupt("return", this._ready);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function ready() {
        return _ready.apply(this, arguments);
      }

      return ready;
    }()
  }, {
    key: "getEmojiByGroup",
    value: function () {
      var _getEmojiByGroup3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(group) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                assertNumber(group);
                _context3.next = 3;
                return this.ready();

              case 3:
                _context3.t0 = uniqEmoji;
                _context3.next = 6;
                return _getEmojiByGroup2(this._db, group);

              case 6:
                _context3.t1 = _context3.sent;
                return _context3.abrupt("return", (0, _context3.t0)(_context3.t1).map(cleanEmoji));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getEmojiByGroup(_x27) {
        return _getEmojiByGroup3.apply(this, arguments);
      }

      return getEmojiByGroup;
    }()
  }, {
    key: "getEmojiBySearchQuery",
    value: function () {
      var _getEmojiBySearchQuery3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(query) {
        var customs, natives;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                assertNonEmptyString(query);
                _context4.next = 3;
                return this.ready();

              case 3:
                customs = this._custom.search(query);
                _context4.t0 = uniqEmoji;
                _context4.next = 7;
                return _getEmojiBySearchQuery2(this._db, query);

              case 7:
                _context4.t1 = _context4.sent;
                natives = (0, _context4.t0)(_context4.t1).map(cleanEmoji);
                return _context4.abrupt("return", [].concat(_toConsumableArray(customs), _toConsumableArray(natives)));

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getEmojiBySearchQuery(_x28) {
        return _getEmojiBySearchQuery3.apply(this, arguments);
      }

      return getEmojiBySearchQuery;
    }()
  }, {
    key: "getEmojiByShortcode",
    value: function () {
      var _getEmojiByShortcode3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(shortcode) {
        var custom;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                assertNonEmptyString(shortcode);
                _context5.next = 3;
                return this.ready();

              case 3:
                custom = this._custom.byShortcode(shortcode);

                if (!custom) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return", custom);

              case 6:
                _context5.t0 = cleanEmoji;
                _context5.next = 9;
                return _getEmojiByShortcode2(this._db, shortcode);

              case 9:
                _context5.t1 = _context5.sent;
                return _context5.abrupt("return", (0, _context5.t0)(_context5.t1));

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getEmojiByShortcode(_x29) {
        return _getEmojiByShortcode3.apply(this, arguments);
      }

      return getEmojiByShortcode;
    }()
  }, {
    key: "getEmojiByUnicodeOrName",
    value: function () {
      var _getEmojiByUnicodeOrName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(unicodeOrName) {
        var custom;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                assertNonEmptyString(unicodeOrName);
                _context6.next = 3;
                return this.ready();

              case 3:
                custom = this._custom.byName(unicodeOrName);

                if (!custom) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt("return", custom);

              case 6:
                _context6.t0 = cleanEmoji;
                _context6.next = 9;
                return getEmojiByUnicode(this._db, unicodeOrName);

              case 9:
                _context6.t1 = _context6.sent;
                return _context6.abrupt("return", (0, _context6.t0)(_context6.t1));

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getEmojiByUnicodeOrName(_x30) {
        return _getEmojiByUnicodeOrName.apply(this, arguments);
      }

      return getEmojiByUnicodeOrName;
    }()
  }, {
    key: "getPreferredSkinTone",
    value: function () {
      var _getPreferredSkinTone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.ready();

              case 2:
                _context7.next = 4;
                return get(this._db, STORE_KEYVALUE, KEY_PREFERRED_SKINTONE);

              case 4:
                _context7.t0 = _context7.sent;

                if (_context7.t0) {
                  _context7.next = 7;
                  break;
                }

                _context7.t0 = 0;

              case 7:
                return _context7.abrupt("return", _context7.t0);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getPreferredSkinTone() {
        return _getPreferredSkinTone.apply(this, arguments);
      }

      return getPreferredSkinTone;
    }()
  }, {
    key: "setPreferredSkinTone",
    value: function () {
      var _setPreferredSkinTone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(skinTone) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                assertNumber(skinTone);
                _context8.next = 3;
                return this.ready();

              case 3:
                return _context8.abrupt("return", set(this._db, STORE_KEYVALUE, KEY_PREFERRED_SKINTONE, skinTone));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setPreferredSkinTone(_x31) {
        return _setPreferredSkinTone.apply(this, arguments);
      }

      return setPreferredSkinTone;
    }()
  }, {
    key: "incrementFavoriteEmojiCount",
    value: function () {
      var _incrementFavoriteEmojiCount2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(unicodeOrName) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                assertNonEmptyString(unicodeOrName);
                _context9.next = 3;
                return this.ready();

              case 3:
                return _context9.abrupt("return", _incrementFavoriteEmojiCount(this._db, unicodeOrName));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function incrementFavoriteEmojiCount(_x32) {
        return _incrementFavoriteEmojiCount2.apply(this, arguments);
      }

      return incrementFavoriteEmojiCount;
    }()
  }, {
    key: "getTopFavoriteEmoji",
    value: function () {
      var _getTopFavoriteEmoji2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(limit) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                assertNumber(limit);
                _context10.next = 3;
                return this.ready();

              case 3:
                _context10.next = 5;
                return _getTopFavoriteEmoji(this._db, this._custom, limit);

              case 5:
                return _context10.abrupt("return", _context10.sent.map(cleanEmoji));

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getTopFavoriteEmoji(_x33) {
        return _getTopFavoriteEmoji2.apply(this, arguments);
      }

      return getTopFavoriteEmoji;
    }()
  }, {
    key: "customEmoji",
    get: function get() {
      return this._custom.all;
    },
    set: function set(customEmojis) {
      this._custom = customEmojiIndex(customEmojis);
    }
  }, {
    key: "_shutdown",
    value: function () {
      var _shutdown2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.ready();

              case 2:
                _context11.prev = 2;
                _context11.next = 5;
                return this._lazyUpdate;

              case 5:
                _context11.next = 9;
                break;

              case 7:
                _context11.prev = 7;
                _context11.t0 = _context11["catch"](2);

              case 9:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[2, 7]]);
      }));

      function _shutdown() {
        return _shutdown2.apply(this, arguments);
      }

      return _shutdown;
    }() // clear references to IDB, e.g. during a close event

  }, {
    key: "_clear",
    value: function _clear() {
      // We don't need to call removeEventListener or remove the manual "close" listeners.
      // The memory leak tests prove this is unnecessary. It's because:
      // 1) IDBDatabases that can no longer fire "close" automatically have listeners GCed
      // 2) we clear the manual close listeners in databaseLifecycle.js.
      this._db = this._ready = this._lazyUpdate = undefined;
    }
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this._shutdown();

              case 2:
                _context12.next = 4;
                return closeDatabase(this._dbName);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this._shutdown();

              case 2:
                _context13.next = 4;
                return deleteDatabase(this._dbName);

              case 4:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function _delete() {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return Database;
}();

export default Database;